import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';
import { PricesTableTotalInfoComponent } from './prices-table-total-info.component';
import { TradePricesApiService } from '../../services/trade-prices-api.service';

@NgModule({
  declarations: [
    PricesTableTotalInfoComponent
  ],
  imports: [
    CommonModule,
    UIComponentsModule,
    RouterModule,
    TranslateModule,
    RnplCommonModule
  ],
  exports: [PricesTableTotalInfoComponent],
  providers: [TradePricesApiService]
})
export class PricesTableTotalInfoModule {}
